/** The Google Analytics 4 measurement ID that the site and the console share. */
export const GA_MEASUREMENT_ID = "G-BR3PX1653S";

export const GTAG_SCRIPT_URL = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
